<template>
  <div>
    <h3>Alterar Senha</h3>

    <div v-if="!alterar_senha" class="text-center mt-6 mb-6">
      <b-button variant="exitos" @click="alterar_senha = true"
        >Alterar Senha</b-button
      >
    </div>

    <div v-else>
      <b-form-group label="Senha atual:">
        <b-form-input
          v-model="user.current_password"
          :state="validateState('current_password')"
          :type="type_password"
          placeholder="Senha"
        ></b-form-input>
        <b-form-invalid-feedback
          >Nome é um campo obrigatório.</b-form-invalid-feedback
        >
      </b-form-group>

      <b-form-group label="Nova Senha:">
        <b-form-input
          v-model="user.password"
          :state="validateState('password')"
          type="password"
          placeholder="Senha"
        ></b-form-input>
        <b-form-invalid-feedback>
          <span v-if="!$v.user.password.minLength"
            >Password requer um mínimo de 6 caracteres.</span
          >
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Confirmar Senha:">
        <b-form-input
          v-model="user.password_confirmation"
          :state="validateState('password_confirmation')"
          type="password"
          placeholder="Confirmar senha"
        ></b-form-input>
        <b-form-invalid-feedback>
          <span v-if="!$v.user.password_confirmation.sameAsPassword"
            >Confirmação está diferente da senha.</span
          >
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="text-right">
        <b-button variant="link" size="sm" @click="alterar_senha = false"
          >Cancelar</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";
import { minLength, sameAs, requiredIf } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data: () => ({
    alterar_senha: false,
    show_password: false,
  }),
  validations: {
    user: {
      current_password: {
        required: requiredIf(function (user) {
          return this.alterar_senha;
        }),
      },
      password: {
        required: requiredIf(function (user) {
          return this.alterar_senha;
        }),
        minLength: minLength(6),
      },
      password_confirmation: {
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    type_password() {
      return this.show_password ? "text" : "password";
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.user.$touch();
      return !this.$v.user.$anyError;
    },
  },
  async created() {},
};
</script>

<style></style>
